<div
  (click)="!isDisabled && !readonly && overlayPanel.toggle($event)"
  class="tw-flex tw-items-center"
>
  <p-iconField
    class="tw-flex tw-items-center tw-w-full full-width"
    iconPosition="left"
  >
    <p-inputIcon>
      <i class="fa-regular fa-calendar-days tw-leading-4 tw-align-middle tw-mb-3"></i>
    </p-inputIcon>
    <input
      pInputText
      [disabled]="isDisabled"
      class="tw-w-full tw-min-w-64"
      [ngModel]="formattedValue"
      readonly
    />
  </p-iconField>

  <i
    *ngIf="infoMsg"
    class="fas fa-info-circle tw-text-primary-400 tw-text-xl tw-ml-2"
    [pTooltip]="infoMsg"
  ></i>

  <i
    *ngIf="invalidDatesMsg"
    class="fas fa-triangle-exclamation tw-text-warning tw-text-xl tw-ml-2"
    [pTooltip]="invalidDatesMsg"
  ></i>
</div>

<p-overlayPanel
  *ngIf="!readonly"
  #overlayPanel
  [appendTo]="'body'"
>
  <div class="tw-table tw-h-1">
    <div class="tw-table-row">
      <div
        *ngIf="!onlyFixed"
        class="tw-table-cell tw-align-top tw-pl-2 tw-pt-2"
      >
        <div class="tw-flex tw-flex-col tw-justify-between tw-w-40 tw-h-full">
          <p-button
            *ngFor="let r of computedRanges"
            severity="secondary"
            [outlined]="r !== selectedDynamic"
            (onClick)="setDynamicRange(r)"
            label="{{ label(r) }}"
            styleClass="tw-w-full tw-h-11 tw-text-left"
          />
        </div>
      </div>
      <div class="tw-w-[560px] tw-pt-2 tw-pb-0 tw-px-4">
        <div>
          <calendar
            class="tw-mb-2"
            [startDate]="startDate"
            [endDate]="endDate"
            [min]="min"
            [max]="max"
            [firstDayOfWeek]="firstDayOfWeek"
            (datesChange)="updateDates($event)"
          ></calendar>
          <div
            *ngIf="!selectedDynamic || selectedDynamic.name !== 'custom'"
            class="tw-flex tw-items-center tw-gap-2"
          >
            <div class="tw-w-1/2 tw-flex tw-items-center">
              <p-iconField
                class="tw-flex tw-items-center tw-w-full full-width"
                iconPosition="left"
              >
                <p-inputIcon>
                  <i class="fa-regular fa-calendar-days tw-leading-4 tw-align-middle tw-mb-3"></i>
                </p-inputIcon>
                <input
                  pInputText
                  class="tw-w-full"
                  [ngModel]="formattedStartDate"
                  (blur)="updateDate('start', $event)"
                  (keyup.enter)="updateDate('start', $event)"
                  [readonly]="selectedDynamic && selectedDynamic.name !== 'fixed'"
                />
              </p-iconField>
            </div>
            <div class="tw-font-medium tw-flex tw-items-center tw-justify-center tw-w-6">-</div>
            <div class="tw-w-1/2 tw-flex tw-items-center">
              <p-iconField
                class="tw-flex tw-items-center tw-w-full full-width"
                iconPosition="left"
              >
                <p-inputIcon>
                  <i class="fa-regular fa-calendar-days tw-leading-4 tw-align-middle tw-mb-3"></i>
                </p-inputIcon>
                <input
                  pInputText
                  class="tw-w-full"
                  [ngModel]="formattedEndDate"
                  (blur)="updateDate('end', $event)"
                  (keyup.enter)="updateDate('end', $event)"
                  [readonly]="selectedDynamic && selectedDynamic.name !== 'fixed'"
                />
              </p-iconField>
            </div>
          </div>
          <div
            *ngIf="!onlyFixed && selectedDynamic && selectedDynamic.name === 'custom'"
            class="tw-flex tw-items-center tw-space-x-2"
          >
            <div class="tw-flex tw-flex-col tw-text-nowrap">
              <p-buttonGroup>
                <p-button
                  styleClass="tw-h-10"
                  severity="secondary"
                  [outlined]="customInterval?.name !== 'this'"
                  label="This"
                  (onClick)="updateCustomInterval({ name: 'this' })"
                />
                <p-button
                  styleClass="tw-h-10"
                  severity="secondary"
                  label="Last"
                  [outlined]="customInterval?.name !== 'last'"
                  (onClick)="updateCustomInterval({ name: 'last' })"
                />
                <p-button
                  styleClass="tw-h-10"
                  severity="secondary"
                  [outlined]="customInterval?.name !== 'next'"
                  label="Next"
                  (onClick)="updateCustomInterval({ name: 'next' })"
                />
              </p-buttonGroup>
            </div>

            <p-inputNumber
              [ngModel]="customInterval?.num || 1"
              [min]="1"
              [max]="999"
              (onInput)="updateCustomInterval({ num: $event.value })"
              inputStyleClass="tw-w-12"
            ></p-inputNumber>

            <div class="tw-w-32">
              <p-dropdown
                [ngModel]="customIntervalUnit"
                optionLabel="name"
                (onChange)="updateCustomInterval({ unit: $event?.value.value })"
                [options]="availableUnits"
                styleClass="tw-w-full"
              />
            </div>

            <p-checkbox
              [ngModel]="customInterval?.toDate"
              (ngModelChange)="updateCustomInterval({ toDate: $event })"
              [binary]="true"
              inputId="toDate"
              [disabled]="
                customInterval?.name !== 'this' ||
                customIntervalUnit.value === 'day' ||
                customIntervalUnit.value === 'week'
              "
            ></p-checkbox>
            <label
              for="toDate"
              class="tw-font-medium tw-cursor-pointer"
            >
              to
            </label>

            <div class="tw-flex tw-flex-col tw-text-nowrap">
              <p-buttonGroup>
                <p-button
                  *ngFor="let option of availableOffsetOptions"
                  styleClass="tw-h-10"
                  severity="secondary"
                  [outlined]="customInterval.offset !== option.value"
                  [label]="option.label"
                  [disabled]="
                    customInterval?.name !== 'this' ||
                    customIntervalUnit.value === 'day' ||
                    customIntervalUnit.value === 'week' ||
                    !customInterval.toDate
                  "
                  (onClick)="updateCustomInterval({ offset: option.value })"
                />
              </p-buttonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tw-flex tw-justify-end tw-gap-2 tw-px-4 tw-pb-2 tw-pt-5">
    <p-button
      severity="secondary"
      (onClick)="cancel()"
      label="Cancel"
    />
    <p-button
      severity="primary"
      (onClick)="apply()"
      label="Apply"
    />
  </div>
</p-overlayPanel>
